import { Route, Routes } from "react-router";
import { CookieConsentSettingsModel } from "./CookieConsentApp";
import CookieConsentDialogWrapper from "./CookieConsentDialogWrapper";

interface Props {
  settings: CookieConsentSettingsModel;
}

const CookieConsent = (props: Props) => {
  return (
    <Routes>
      <Route path="/cookie-policy/" />
      <Route path="/sv/cookie-policy/" />
      <Route path="/privacypolicy/" />
      <Route path="/sv/privacypolicy/" />
      <Route path="/*" element={<CookieConsentDialogWrapper settings={props.settings} />} />
    </Routes>
  );
};
export default CookieConsent;
